<template>
  <aside
    class="voter-info-sidebar"
    aria-labelledby="voter-info-sidebar-title"
  >
    <h3
      id="voter-info-sidebar-title"
      class="text-xs"
    >
      {{ $t('cac.app.double_check_info') }} {{ stateName }}.
    </h3>

    <div class="voter-info-sidebar__buttons my-4">
      <a
        v-for="{ href, text } of sidebarLinks"
        :key="href"
        :href="href"
        class="btn btn--primary my-3"
        target="_blank"
      >
        {{ $t(text) }}
      </a>
    </div>

    <div class="voter-info-sidebar__address background-light p-2 text-sm">
      <strong
        v-if="sosInformation.name"
        class="d-block"
      >
        {{ sosInformation.name }}
      </strong>
      <div
        v-if="sosInformation.address"
        class="pre-line mb-2"
        v-html="sosInformation.address"
      />
      <a
        v-if="sosInformation.phone"
        :href="'tel:' + sosInformation.phone"
      >
        {{ sosInformation.phone }}
      </a>
    </div>
  </aside>
</template>

<script>
export default {
  name: "VoterInformationSidebarContent",
  props: {
    stateName: {
      type: String,
      required: true
    },
    sidebarLinks: {
      type: Array,
      required: true
    },
    sosInformation: {
      type: Object,
      required: true
    }
  }
};
</script>
